import { ESessionFeatures } from '@/types/session-features.types';
import { THandleUpdateProjectFeatureProps } from '../../edit-session-features/update-methods/update-methods.types';
import { saveWorkingProject } from '@/store/slices/project';

const handleUpdateFeaturesByProject = async ({
  project,
  toggledFeature,
  dispatch,
}: THandleUpdateProjectFeatureProps) => {
  if (project === null) {
    return;
  }
  switch (toggledFeature) {
    case ESessionFeatures.COURSES: {
      const isOn = !!project?.settings?.course_enabled;
      // we're only saving this value if truthy, which means user will not be able to disable courses once enabled..
      // likely to be revisited..
      if (!isOn) {
        dispatch(
          saveWorkingProject({
            project: {
              ...project,
              settings: {
                ...project.settings,
                course_enabled: !isOn,
              },
            },
          })
        );
      }
      break;
    }
  }
};

export default handleUpdateFeaturesByProject;
